module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/kitchen-scale-46e2b4dafa2dd5e5deb505ad4a00eb43.svg";